import React, { ReactNode } from 'react';
import styled from 'styled-components';

import Box from 'components/Box';
import { H3 } from 'components/Text';
import Tile, { TileBody } from 'components/Tile';

const StyledTile = styled(Tile)`
  margin-bottom: 36px;
  &:not(:first-child) {
    margin: 36px 0;
  }
`;
const StyledTileBody = styled(TileBody)`
  & > *:last-child {
    margin-bottom: 0;
  }
`;

type Props = {
  title?: ReactNode;
  description?: ReactNode;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
  large?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  bodyProps?: Record<string, any>;
};

export function Section({
  title,
  description,
  children,
  large,
  bodyProps = {},
  ...props
}: Props) {
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledTile {...props}>
      <StyledTileBody
        p={large ? [48, null, 96] : [20, null, 40]}
        pt={large && [36, null, 64]}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...bodyProps}
      >
        {title && <H3 mb={large && !description ? 56 : undefined}>{title}</H3>}
        {description && <Box mb={large ? 56 : undefined}>{description}</Box>}
        {children}
      </StyledTileBody>
    </StyledTile>
  );
}
